import React from "react";
import { OrgDownloadContextType } from "./types";

export const OrgDownloadContext = React.createContext<
  OrgDownloadContextType | undefined
>(undefined);
